import { render, staticRenderFns } from "./PrintLabels.vue?vue&type=template&id=721b703e&"
import script from "./PrintLabels.vue?vue&type=script&lang=js&"
export * from "./PrintLabels.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabels.vue?vue&type=style&index=0&id=721b703e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports